/**
 * Connection lost: every attempt to reconnect has failed, and nothing more
 * happens until the player acts. The coral notice over the page, over any
 * screen and any dialog: the rail's lost mark, the game's sentence, and
 * Reconnect — the one thing left to do, so the gold action. There is no close
 * and no Escape: it waits.
 *
 * It lives with the other notices over the page, but the app's root mounts
 * it, in every mode (app.tsx), since a lost connection outlives the game
 * screen: with Reconnect's way back to the entry, as the game screen gives the
 * other notices theirs (match-overlays.tsx). It opens as the notice over the
 * page (domains/notices.ts), on its own store
 * (domains/connection-lost.ts), which the connection service sets once its
 * last attempt fails.
 */

import { useTranslation } from 'react-i18next';

import { Button } from '../../../ui/button';
import { GLYPH } from '../../../ui/glyphs';
import { NoticeDialog } from '../../../ui/notice-dialog';
import { useOpenNotice } from '../../../../domains/notices';

export function ConnectionLostNotice({ onReconnect }: { onReconnect: () => void }) {
  const { t } = useTranslation();
  const open = useOpenNotice() === 'connectionLost';

  return (
    <NoticeDialog
      open={open}
      role="alertdialog"
      tone="danger"
      glyph={GLYPH.warning}
      title={t('game.connectionLost')}
      description={t('game.connectionLostMessage')}
      actions={
        <Button tone="primary" onClick={onReconnect}>
          {t('game.reconnect')}
        </Button>
      }
    />
  );
}
